import axios from 'axios';
import { API_BASE_URL, handleApiError } from './_apiBase';

export type DefaultOperation = 'reporting' | 'write';

export interface ZigbeeDefaultSetting {
    id: number;
    manufacturer_name: string;   // '' = any manufacturer
    model_id: string;            // '' = any model
    operation: DefaultOperation;
    cluster: string;
    attribute: string;
    endpoint: number | null;     // null = all supporting endpoints
    min_interval: number | null;
    max_interval: number | null;
    reportable_change: number | null;
    write_value: number | null;
    enabled: boolean;
    description: string | null;
}

export type ZigbeeDefaultSettingInput = Omit<ZigbeeDefaultSetting, 'id'>;

export const fetchZigbeeDefaultSettings = async (): Promise<ZigbeeDefaultSetting[]> => {
    try {
        const res = await axios.get(`${API_BASE_URL}/zigbee-default-settings`);
        return res.data;
    } catch (error) { return handleApiError(error, 'Hämta standardinställningar för Zigbee'); }
};

export const createZigbeeDefaultSetting = async (data: ZigbeeDefaultSettingInput): Promise<ZigbeeDefaultSetting> => {
    try {
        const res = await axios.post(`${API_BASE_URL}/zigbee-default-settings`, data);
        return res.data;
    } catch (error) { return handleApiError(error, 'Skapa standardinställning för Zigbee'); }
};

export const updateZigbeeDefaultSetting = async (id: number, data: Partial<ZigbeeDefaultSettingInput>): Promise<any> => {
    try {
        const res = await axios.put(`${API_BASE_URL}/zigbee-default-settings/${id}`, data);
        return res.data;
    } catch (error) { return handleApiError(error, 'Spara standardinställning för Zigbee'); }
};

export const deleteZigbeeDefaultSetting = async (id: number): Promise<any> => {
    try {
        const res = await axios.delete(`${API_BASE_URL}/zigbee-default-settings/${id}`);
        return res.data;
    } catch (error) { return handleApiError(error, 'Ta bort standardinställning för Zigbee'); }
};
